module.exports = __webpack_public_path__ + "img/HydrophoneThumbnail.964ea41b.png";